import { render, staticRenderFns } from "./view.html?vue&type=template&id=3ba4acfc&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=3ba4acfc&lang=less&scoped=true&"
import style1 from "./style_notebook.less?vue&type=style&index=1&id=3ba4acfc&lang=less&scoped=true&"
import style2 from "./style_mobile.less?vue&type=style&index=2&id=3ba4acfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba4acfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ba4acfc')) {
      api.createRecord('3ba4acfc', component.options)
    } else {
      api.reload('3ba4acfc', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=3ba4acfc&scoped=true&", function () {
      api.rerender('3ba4acfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shop/mall/index.vue"
export default component.exports